import Flex from '@Components/Bases/Flex';
import { Box, Typography } from '@mui/material';

import MarketPolicyLastYearIntroduction, {
  MARKET_LAST_YEAR_INTRODUCTION_ID,
} from './MarketPolicyLastYearIntroduction';
import MarketPolicyLastYearRemark, {
  MARKET_LAST_YEAR_REMARK_ID,
} from './MarketPolicyLastYearRemark';
import MarketPoliciesDescriptionForm from './MarketPoliciesDescriptionForm';
import MarketPoliciesSelectTypes from './MarketPoliciesSelectTypes';

const MarketPoliciesForm = () => {
  return (
    <Box width={1} mt={2}>
      <Flex gap={1} alignContent={'center'}>
        <Typography fontWeight={800}>
          นโยบายการตลาดของผลิตภัณฑ์หรือบริการที่สำคัญในปีที่ผ่านมา
        </Typography>
        <Flex gap={0.5} alignItems={'center'}>
          <MarketPolicyLastYearIntroduction />
          <MarketPolicyLastYearRemark />
        </Flex>
      </Flex>
      <Box id={MARKET_LAST_YEAR_INTRODUCTION_ID} />
      <MarketPoliciesSelectTypes />
      <MarketPoliciesDescriptionForm />
      <Box id={MARKET_LAST_YEAR_REMARK_ID} />
    </Box>
  );
};

export default MarketPoliciesForm;
